import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query クライアント
 *
 * グローバルなキャッシュ戦略とデフォルト設定を定義
 *
 * FSD Shared層の責務:
 * - アプリケーション全体で共有されるQueryClientインスタンス
 * - ビジネスロジックに依存しない技術的な設定
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5分間キャッシュ
      gcTime: 1000 * 60 * 10, // 10分間ガベージコレクション保持
      retry: 3, // 失敗時3回リトライ
      refetchOnWindowFocus: false, // ウィンドウフォーカス時の自動再取得を無効化
    },
  },
});
